import { types } from 'mobx-state-tree';

export enum ModalType {
  DeveloperMenu = 'DeveloperMenu',
  DetailPane = 'DetailPane',
  Search = 'Search',
  Settings = 'Settings',
  Login = 'Login',
}

const modalTypes = Object.values(ModalType);

export const PageStore = types
  .model('PageStore', {
    currentModal: types.maybe(types.enumeration(modalTypes)),
    selectedSettingPath: types.maybe(types.string),
    sidebarPath: types.maybe(types.string), // kept in sync via usePagePathSyncer
  })
  .actions((self) => ({
    openModal(modalType: ModalType) {
      self.currentModal = modalType;
    },
    closeModal() {
      self.currentModal = undefined;
    },
    setSelectedSettingPath(setting: string | undefined) {
      self.selectedSettingPath = setting;
    },
    setSidebarPath(path: string | undefined) {
      self.sidebarPath = path;
    },
  }))
  .views((self) => ({
    isSettingsModalOpen: () => self.currentModal === ModalType.Settings,
    isLoginModalOpen: () => self.currentModal === ModalType.Login,
  }));

export const createPageStore = () => {
  return PageStore.create({});
};
export type TPageStore = ReturnType<typeof createPageStore>;
